export default function validatePdfPassword(pdfPassword: string) {
  let success = false;
  let message = '';
  if (pdfPassword.length < 6) {
    message = '6자 이상 입력해 주세요.';
  } else if (pdfPassword.length > 32) {
    message = '32자 이하로 입력해 주세요.';
  } else {
    success = true;
  }

  return { success, message };
}
